import { createAsyncAction } from 'typesafe-actions';
import { ErrorPayload } from '../callApi';
import { EmptyPayload } from './main/types';

export function doCreateAsyncActionResource<
  TRequestPayload,
  TSuccessPayload,
  TErrorPayload,
  TCancelPayload = EmptyPayload,
>(displayName: string, actionName: string) {
  // if changing these action types, actionTypeFor<X> functions below also need to be updated
  return createAsyncAction(
    `@${displayName}/${actionName}/request`,
    `@${displayName}/${actionName}/success`,
    `@${displayName}/${actionName}/failure`,
    `@${displayName}/${actionName}/cancel`,
  )<TRequestPayload, TSuccessPayload, TErrorPayload, TCancelPayload>();
}

export function createAsyncActionResource<TRequestPayload, TSuccessPayload>(
  displayName: string,
  actionName: string,
) {
  // if changing these action types, actionTypeFor<X> functions below also need to be updated
  return doCreateAsyncActionResource<
    TRequestPayload,
    TSuccessPayload,
    ErrorPayload
  >(displayName, actionName);
}

export function actionTypeForSuccess(type: string) {
  if (!type.endsWith('/request')) {
    throw new Error('Unsupported actionType ' + type);
  }
  return type.substring(0, type.length - '/request'.length) + '/success';
}

export function actionTypeForFailure(type: string) {
  if (!type.endsWith('/request')) {
    throw new Error('Unsupported actionType ' + type);
  }
  return type.substring(0, type.length - '/request'.length) + '/failure';
}

export function actionTypeForCancel(type: string) {
  if (!type.endsWith('/request')) {
    throw new Error('Unsupported actionType ' + type);
  }
  return type.substring(0, type.length - '/request'.length) + '/cancel';
}
